import {
   AfterViewInit,
   Component,
   ElementRef,
   EventEmitter,
   Inject,
   Input,
   OnInit,
   Output,
   ViewChild
} from '@angular/core';
import {ServerService} from "../../../services/server.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
   selector: 'app-image-zoom',
   templateUrl: './image-zoom.component.html',
   styleUrls: ['./image-zoom.component.scss']
})
export class ImageZoomComponent implements OnInit, AfterViewInit {
   @ViewChild('container') 'container': ElementRef;
   @ViewChild('img') 'img': ElementRef;

   @Output() clickCloseDialog: EventEmitter<any> = new EventEmitter<any>()


   @Input() myThumbnail
   @Input() myFullresImage
   @Input() pVariantId
   images: any

   constructor(private serverSrv: ServerService,
               public dialogRef: MatDialogRef<ImageZoomComponent>,
               @Inject(MAT_DIALOG_DATA) public data: {data:any, prod_var_instance_id:number, vendorSlug:number}
               ) { }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      this.fetchImages()
   }

   fetchImages(){
      this.serverSrv.getAll(null, `/api/esercizi/${this.data.vendorSlug}/prod_var_instances/${this.data.prod_var_instance_id}/images`).then(res => {
         this.images = res.map((oggetto) => oggetto.image);
      })
   }

   openLink(url){
      return this.serverSrv.getPrivateMedia(url)
   }

   clickClose() {
      this.clickCloseDialog.emit()
   }
}
